import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class WebToAppCtaModuleTerms extends BaseTerms {
  WEB_TO_APP_MAIN_TEXT = "Continue in app text";
  WEB_TO_APP_SECONDARY_TEXT = "Secondary text";
  WEB_TO_APP_OPEN_BROWSER = "continue in browser";
  WEB_TO_APP_OPEN_APP = "continue in App";
}
